import { StartupMode } from '../../types/AppSettings';
import { DateFormat, Locale } from '../../types/A3';
import { WeekStartsOnDay, isValidWeekStartsOn } from '../../helper';
import backendFetchV2 from '../../api/backendFetchV2';
import { getUserProperties } from './getUserProperties';
import { HISTORY_DATA_FETCH_LIMITS, HistoryDataFetchLimit } from '../../config';

export const updateAutoLoadType = async (value: StartupMode) => {
  const {
    account: { id: organizationId },
    user: { id: userId },
  } = VSS.getWebContext();

  const userProperties = await getUserProperties();

  const body = {
    ...userProperties,
    startupMode: value,
  };

  return backendFetchV2<{}>(`/actionable-agile/api/user-properties`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-55d-org-id': organizationId,
      'x-55d-user-id': userId,
    },
    body: body,
  });
};

export const updateLastLoadedDatasetId = async (value: string) => {
  const {
    account: { id: organizationId },
    user: { id: userId },
  } = VSS.getWebContext();

  const userProperties = await getUserProperties();
  const body = {
    ...userProperties,
    lastLoadedDatasetId: value,
  };

  return backendFetchV2<{}>(`/actionable-agile/api/user-properties`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-55d-org-id': organizationId,
      'x-55d-user-id': userId,
    },
    body: body,
  });
};

export const updateDateFormat = async (value: DateFormat) => {
  return new Promise<DateFormat>((resolve, reject) => {
    if (!value) {
      reject(new Error('Empty Date Format'));
    }

    resolve(value);
  });
};

export const updateLocale = async (value: Locale) => {
  return new Promise<Locale>((resolve, reject) => {
    if (!value) {
      reject(new Error('Empty Locale'));
    }

    resolve(value);
  });
};

export const updateWeekStartsOn = async (value: WeekStartsOnDay) => {
  return new Promise<WeekStartsOnDay>((resolve, reject) => {
    if (!isValidWeekStartsOn(value)) {
      reject(new Error('Invalid week starts on value'));
      return;
    }

    resolve(value);
  });
};

export const updateHistoryFetchLimit = async (value: HistoryDataFetchLimit) => {
  return new Promise<HistoryDataFetchLimit>((resolve, reject) => {
    if (!HISTORY_DATA_FETCH_LIMITS.includes(value)) {
      reject(new Error('Invalid Historical Data Fetch Limit on value'));
      return;
    }

    resolve(value);
  });
}
